import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SaLibraryComponent } from './sa-library.component';
import { authGuard } from '../../shared/guards/auth.guard';
import { DocumentDetailsComponent } from './document-details/document-details.component';
import { saLibraryPageGuard } from '../../shared/guards/role.guard';

const routes: Routes = [
  {
    path: 'sa-library',
    component: SaLibraryComponent,
    canActivate: [authGuard, saLibraryPageGuard]
  },
  {
    path: 'sa-library/:documentUri',
    component: DocumentDetailsComponent,
    canActivate: [authGuard, saLibraryPageGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SaLibraryRoutingModule { }
